import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import CommonTextField from "components/common/CommonTextField";

const PLAN_PRICES = {
  "Mind Pulse Heart": "0.00",
  "Mind Pulse Core": "5.99",
  "Mind Pulse Expand": "6.99",
  "Mind Pulse Optimum": "7.99",
};

const CreateUser = ({ isOpen, onClose, onSubmit }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  const [plan, setPlan] = useState("");
  const [planPrice, setPlanPrice] = useState("");
  const [planStartDate, setPlanStartDate] = useState("");
  const [planSeats, setPlanSeats] = useState("");

  useEffect(() => {
    if (!isOpen) clearForm();
  }, [isOpen]);

  const clearForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setMobile("");
    setPassword("");
    setPlan("");
    setPlanPrice("");
    setPlanStartDate("");
    setPlanSeats("");
  };

  const handlePlanChange = (value) => {
    setPlan(value);
    if (PLAN_PRICES[value]) {
      setPlanPrice(PLAN_PRICES[value]);
    }
  };

  const handleCreate = () => {
    const payload = {
      firstName,
      lastName,
      email,
      mobile,
      password,
      status: true,
      plan,
      planPrice,
      planStartDate,
      planSeats,
    };

    onSubmit?.(payload);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl p-6 relative flex flex-col max-h-[90vh] overflow-hidden">
        <div className="flex-1 overflow-y-auto pr-2">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-lg font-semibold">Create User</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <IoCloseOutline size={24} />
            </button>
          </div>

          <div className="space-y-4">
            <CommonTextField
              label="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="First Name"
            />

            <CommonTextField
              label="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Last Name"
            />

            <CommonTextField
              label="Email"
              type={"email"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@example.com"
            />

            <CommonTextField
              label="Mobile Number (E.164 - AU)"
              type={"number"}
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="+61412345678"
            />

            {/* PASSWORD */}
            <CommonTextField
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
            />

            {/* Plan */}
            <div>
              <p className="mb-1 font-semibold text-sm text-gray-800">
                Subscription Plan
              </p>
              <select
                onChange={(e) => handlePlanChange(e.target.value)}
                value={plan}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
              >
                <option value="">Select a Plan</option>
                <option value="Mind Pulse Heart">Heart</option>
                <option value="Mind Pulse Core">Core</option>
                <option value="Mind Pulse Expand">Expand</option>
                <option value="Mind Pulse Optimum">Optimum</option>
              </select>
            </div>

            <CommonTextField
              label="Plan Price per User"
              value={planPrice}
              type="number"
              onChange={(e) => setPlanPrice(e.target.value)}
              placeholder="$0.00"
            />

            <CommonTextField
              label="Plan Start Date"
              type="date"
              value={planStartDate}
              onChange={(e) => setPlanStartDate(e.target.value)}
            />

            <CommonTextField
              label="Number of Seats"
              type="number"
              value={planSeats}
              onChange={(e) => setPlanSeats(e.target.value)}
              placeholder="10"
            />
          </div>
        </div>

        <div className="flex justify-between mt-4">
          <button
            onClick={onClose}
            className="w-1/2 mr-2 bg-gray-200 text-gray-800 py-2 px-4 rounded-md text-sm font-medium hover:bg-gray-300"
          >
            Cancel
          </button>

          <button
            onClick={handleCreate}
            className="w-1/2 ml-2 bg-blue-600 text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-blue-700"
          >
            Create User
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
